export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6262.43c87d20.jpg";